export const API_URL_LOGIN = process.env.API_LOGIN;
export const API_URL_PREFIX = process.env.API_PREFIX;
export const PHOTO_REVIEW_IMAGE_URL_BASE = process.env.PHOTO_REVIEW_IMAGE_URL_BASE;

// Password-reset request endpoint. No such endpoint exists on the API yet, so this is
// unset by default and the forgot-password screen says so rather than failing silently.
export const API_URL_PASSWORD_RESET = process.env.API_PASSWORD_RESET;

// Number of options fetched per page for paginated/searchable entity dropdowns.
export const DROPDOWN_PAGE_SIZE = 50;

// Debounce (ms) applied to filter/search typing before it triggers a request.
export const FILTER_DEBOUNCE_MS = 500;

export const modelMap = {
  merchandiser: "merchandisers",
  merchandisers: "merchandisers/",
  supervisor: "supervisors/",
  created_by: "supervisors-and-supervisor-managers/",
  filters: "filters/",

  // Excalibur's SHORT counterparty list (id, name, address, phone_number, remaining_funds) — the
  // pick-a-counterparty dropdowns (orders/returns filters). It honours `search` only; every other
  // filter is ignored. The full `excalibur/counterparties/` is the /sales/counterparties table's.
  counterparty: "excalibur/counterparties/short/",
  // Excalibur departments (id is a UUID, plus name) — the /sales/counterparties department filter.
  department: "excalibur/departments/",
  // The counterparty card's three dictionaries share ONE endpoint; the caller narrows it with a
  // fixed `extraQuery` (`kind`). It lists live (not deleted) values only. Rows are
  // `{id (UUID), kind, label, order}` — they carry `label`, not `name`, which
  // `maptoSelect2Objects` falls back to.
  client_type: "excalibur/dictionary-values/",
  client_category: "excalibur/dictionary-values/",
  sales_channel: "excalibur/dictionary-values/",
  // The card's "Linked counterparties" picker — the same endpoint, `kind=counterparty_link_type`.
  counterparty_link_type: "excalibur/dictionary-values/",
  // The card's address modal — the same endpoint, `kind=address_type`.
  address_type: "excalibur/dictionary-values/",
  // The card's contact modal — the same endpoint, `kind=contact_role`.
  contact_role: "excalibur/dictionary-values/",

  route: "routes",
  task: "tasks",

  clients: "clients/",
  point: "points",
  points: "points",
  point_groups: "point_groups",
  visit: "visits",
  network: "networks/",
  point__network: "networks/",
  networks: "networks/",
  point__networks: "networks/",
  county: "counties/",
  locality: "localities",
  country: "countries/",
  countries: "countries/",
  categories_point: "categories_point/",
  language: "language",
  brand: "brands",
  brands: "brands",
  product: "products",
  products: "products",
  categories: "categories/",
  subcategory: "subcategories/",
  subcategories: "subcategories/",
  tag: "tags/",
  tags: "tags/",
  component: "components",
  company: "companies",
  template: "templates/",
  absence_reason_templates: "absence-reason-templates/",
};

export const STATIC_ENTITES = {
  task_negative: [
    { id: true, name: "ТАК" },
    { id: false, name: "НІ" },
  ],

  task_deadline: [
    { id: true, name: "ТАК" },
    { id: false, name: "НІ" },
  ],

  task_status: [
    { id: "no_answers", name: "Не виконані" },
    { id: "on_review", name: "На затверджені" },
    { id: "done", name: "Виконані" },
  ],
};

export const EntityDropDownSettings = {
  filters: { action: "list", title: c => c.label, selectTitle: "custom_filter" },
  merchandiser: { action: "list", title: c => c.first_name + " " + c.last_name, selectTitle: "merchandiser" },
  merchandisers: { action: "list", title: c => c.first_name + " " + c.last_name, selectTitle: "merchandisers" },
  supervisor: { action: "list", title: c => c.first_name + " " + c.last_name, selectTitle: "supervisor" },

  // Was missing entirely, so the clients dropdown rendered with no placeholder at all.
  clients: { action: "list", title: c => c.name, selectTitle: "clients" },

  counterparty: { action: "list", title: c => c.name, selectTitle: "counterparty" },

  point: { action: "list", title: c => c.name + " " + c.address, selectTitle: "point" },
  points: { action: "list", title: c => c.name + " " + c.address, selectTitle: "points" },
  point_groups: { action: "list", title: c => c.name, selectTitle: "group_point_select_placeholder" },
  network: { action: "list", title: c => c.name, selectTitle: "network" },
  point__network: { action: "list", title: c => c.name, selectTitle: "network" },
  point__networks: { action: "list", title: c => c.name, selectTitle: "network" },
  networks: { action: "list", title: c => c.name, selectTitle: "networks" },
  created_by: { action: "list", title: c => c.name, selectTitle: "created_by" },

  county: { action: "list", title: c => c.name, selectTitle: "region" },
  locality: { action: "list", title: c => c.name, selectTitle: "city" },
  country: { action: "list", title: c => c.name, selectTitle: "country" },
  countries: { action: "list", title: c => c.name, selectTitle: "countries" },
  categories_point: { action: "list", title: c => c.name, selectTitle: "category" },

  brand: { action: "list", title: c => c.name, selectTitle: "brand" },
  brands: { action: "list", title: c => c.name, selectTitle: "brands" },

  product: { action: "list", title: c => c.name, selectTitle: "product" },
  products: { action: "list", title: c => c.name, selectTitle: "products" },

  category: { action: "list", title: c => c.name, selectTitle: "category" },
  categories: { action: "list", title: c => c.name, selectTitle: "categories" },

  subcategory: { action: "list", title: c => c.name, selectTitle: "subcategories" },
  subcategories: { action: "list", title: c => c.name, selectTitle: "subcategories" },

  tag: { action: "list", title: c => c.name, selectTitle: "tag" },
  tags: { action: "list", title: c => c.name, selectTitle: "tags" },

  component: { action: "list", title: c => c.name, selectTitle: "component" },
  template: { action: "list", title: c => c.name, selectTitle: "template" },
  absence_reason_templates: { action: "list", title: c => c.reason, selectTitle: "absence_reason_templates" },

  task_status: { action: "list", title: c => c.name, selectTitle: "task_status" },
  task_negative: { action: "list", title: c => c.name, selectTitle: "task_negative" },
  task_deadline: { action: "list", title: c => c.name, selectTitle: "task_deadline" },
  date_range: { action: "list", title: c => c.name, selectTitle: "date_range" },
};

export const dataTableConfig = {
  sizePerPage: 50,
  page: 1,
  totalDataSize: 0,
  sizePerPageList: [50, 100, 1000],
  pageStartIndex: 1,
  paginationSize: 3,
  prePage: "Previous",
  nextPage: "Next",
  firstPage: "First",
  lastPage: "Last",
  paging: false,
};
